export const VIEW_MORE_MENU = [
  {
    id: 3,
    title: 'Asuransi',
    spriteSelector: '--insurance',
  },
  {
    id: 2,
    title: 'Tools',
    spriteSelector: '--tools',
  },
  {
    id: 1,
    title: 'Explore',
    spriteSelector: '--explore',
  },
];
